import React from "react";
import { Button, Card, Col, Modal } from "react-bootstrap";
import { ToastContainer } from "react-toastify";

import rate from "../../Images/rate.png";

import ProductCardHook from "../../hook/product/ProductCardHook";
import AddToCartHook from "../../hook/cart/AddToCartHook";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import { useSelector } from "react-redux";
import calculatePriceForProductItem from "../../helpers/calculatePriceForProductItem";
import { animateToCart } from "../../helpers/cartAnimation";

const ProductCard = ({ item, favProduct  }) => {

  const settingsRes = useSelector((state) => state.settingsReducers.settings);
  const [favImg, handleFav] = ProductCardHook(item, favProduct);
  const { t } = useTranslation();

  let priceOffer=0;
  if(item.Offer!=null) priceOffer= calculatePriceForProductItem(item);

  let price=0;

if(item.Offer==null){
	price=item?.hasVariant ?  item?.defaultVariant?.price: item?.price1;
}
else{
price=Number(priceOffer);
}

  const currencytype =
    Cookies.get("i18next") == "ar"
      ? settingsRes.data?.defaultCurrancy.ar
      : settingsRes.data?.defaultCurrancy.en;
  const [
   colorClick,
    indexColor,
    handleAddToCart,
    webSiteData,
    showReviews,
    onClickProduct,
    show,
    handleClose,
    sizeClick,
    sizeIndex,
    addProductColorSizeToCart,
    showVariantModal,
    variantModal,
    setShowVariantModal,
    handleAddToCartWithOutLogin
  ] = AddToCartHook(item._id, item,price);

  let isLogin = JSON.parse(localStorage.getItem("user"));

  console.log('user cart',!isLogin ? true : false);

 
   

//console.log('price',price);
  

  return (
    <Col xs="6" sm="6" md="4" lg="3" className="d-flex">
      <Modal show={show} onHide={handleClose} className="sizeModal">
        <Modal.Header>
          <Modal.Title>
            <div className="font">{t("Colors and sizes")}</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {item?.colors.length >= 1 && (
            <>
              <div className="file-input-label-text font">
                {t("Available colors")}
              </div>
              <div md="12" className="mt-1 d-flex flex-wrap">
                {item.colors
                  ? item.colors.map((el, index) => (
                    <div
                      key={index}
                      onClick={() => colorClick(index, el)}
                      className="color ms-2 d-flex"
                      style={{
                        backgroundColor: el,
                        border:
                          indexColor === index ? "2px solid black" : null,
                        width: "20px",
                        height: "20px",
                        boxShadow: "rgb(151 151 151) 0px 4px 4px 0px",
                      }}
                    ></div>
                  ))
                  : null}
              </div>
            </>
          )}

          {item?.classifications.length >= 1 && (
            <>
              <div className="file-input-label-text font">
                {t("Available sizes")}
              </div>
              <div md="12" className="mt-2 d-flex flex-wrap flex-column">
                {item.colors
                  ? item.classifications.map((el, index) => (
                    <div
                      key={index}
                      onClick={() => sizeClick(index, el)}
                      className=" ms-2 d-flex justify-content-center align-items-center file-input-label-text p-1 mb-1"
                      style={{
                        width: "100%",
                        border:
                          sizeIndex === index ? "3px solid black" : null,
                        borderRadius: "5px",
                        cursor: "pointer",
                        boxShadow: "rgb(151 151 151) 0px 4px 4px 0px",
                      }}
                    >
                      {el}
                    </div>
                  ))
                  : null}
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button className="font" variant="secondary" onClick={handleClose}>
            {t("retreat")}
          </Button>
          <Button
            className="font"
            variant="success"
            onClick={() =>{
              addProductColorSizeToCart();
            } }
          >
            {t("Confirmation")}
          </Button>
        </Modal.Footer>
      </Modal>

      

      <Card
        className="m-2 modern-product-card"
        onClick={() => onClickProduct(item._id)}
        style={{
          width: "100%",
          height: "auto",
          borderRadius: "8px",
          border: "none",
          backgroundColor: "#FFFFFF",
          cursor: "pointer",
        }}
      >
        {/* Image Area */}
        <div style={{ position: 'relative', padding: '20px 16px 10px', backgroundColor: '#fff' }}>
          {/* Out of stock overlay */}
          {item.countInStock == 0 && item.productCodeDropShipping == '' ? (
            <div style={{
              position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
              backgroundColor: 'rgba(255,255,255,0.7)', display: 'flex',
              alignItems: 'center', justifyContent: 'center', zIndex: 2,
            }}>
              <span style={{ backgroundColor: '#e53935', color: '#fff', padding: '4px 12px', borderRadius: '4px', fontSize: '11px', fontWeight: 600 }}>
                {t("product not found in stock")}
              </span>
            </div>
          ) : null}

          {/* Fav button - top right */}
          <div style={{ position: 'absolute', top: '10px', right: '10px', zIndex: 3 }}
               onClick={(e) => { e.stopPropagation(); }}>
            <img
              onClick={handleFav}
              src={favImg}
              alt="favorite"
              className="fav-icon-heart"
              loading="lazy"
            />
          </div>

          {/* Product Image */}
          <img
            style={{
              height: "170px",
              width: "100%",
              objectFit: "contain",
              display: "block",
            }}
            src={item.image === "" ? "http://shelly-ksa.com/public/uploads/shellyLogo.jpg-1674397778957.jpeg" : item.image}
            alt={Cookies.get("i18next") === "ar" ? item.nameAr : item.nameEn}
            loading="lazy"
          />
        </div>

        {/* Info Area */}
        <div style={{ padding: '8px 12px 14px' }}>
          {/* Product Name - 2 lines max */}
          <div style={{
            fontSize: '13px', fontWeight: 400, color: '#404553', lineHeight: '1.4',
            overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box',
            WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', minHeight: '36px',
            marginBottom: '8px',
          }}>
            {Cookies.get("i18next") === "ar" ? item.nameAr : item.nameEn}
          </div>

          {/* Price */}
          <div style={{ marginBottom: '8px' }}>
            {item.Offer == null ? (
              <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}>
                <span style={{ fontSize: '17px', fontWeight: 800, color: '#222' }}>
                  {item?.hasVariant ? item?.defaultVariant?.price.toFixed(2) : item?.price1.toFixed(2)}
                </span>
                <span style={{ fontSize: '12px', color: '#8b8d94', fontWeight: 400 }}>{currencytype}</span>
              </div>
            ) : (
              <div>
                <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}>
                  <span style={{ fontSize: '17px', fontWeight: 800, color: '#222' }}>
                    {Number(priceOffer).toFixed(2)}
                  </span>
                  <span style={{ fontSize: '12px', color: '#8b8d94' }}>{currencytype}</span>
                </div>
                <del style={{ color: '#c1c3c8', fontSize: '12px' }}>
                  {item?.hasVariant ? Number(item?.defaultVariant?.price).toFixed(2) : Number(item?.price1).toFixed(2)} {currencytype}
                </del>
              </div>
            )}
          </div>

          {/* Rating row */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '3px', fontSize: '12px' }}>
              <span style={{ color: '#f5a623' }}>★</span>
              <span style={{ fontWeight: 600, color: '#404553' }}>{item.ratingsAverage ? item.ratingsAverage.toFixed(1) : "0.0"}</span>
              <span style={{ color: '#8b8d94' }}>({item.ratingsQuantity || 0})</span>
            </div>
          </div>

          {/* Hidden cart button - only shows on hover */}
          <div
            className="noon-card-cart-btn"
            onClick={(e) => {
              e.stopPropagation();
              animateToCart(e, item.image === "" ? "http://shelly-ksa.com/public/uploads/shellyLogo.jpg-1674397778957.jpeg" : item.image);
              if (!isLogin && settingsRes?.data?.hasNotLoginCart == true) {
                handleAddToCartWithOutLogin();
              } else {
                handleAddToCart();
              }
            }}
            style={{
              backgroundColor: settingsRes?.data?.cartColor ? settingsRes?.data?.cartColor : settingsRes?.data?.primaryColor,
            }}
          >
            <i className="fa-solid fa-cart-arrow-down" style={{ marginLeft: '6px' }}></i> {t("Add to cart")}
          </div>
        </div>
      </Card>
    </Col>
  );
};

export default ProductCard;


